/*
 ** TABLE OF CONTENTS
 **
 ** 1) Functions referenced later
 **    - NPER()
 **    - CUMIPMT()
 **    - FV()
 **    - PMT()
 **    - Number.prototype.format
 **    - getMonthName
 **
 ** 2) Calculations
 **    - calculateLoan()
 **    - calculateRefinance()
 **    - calculateRepayment()
 */

function NPER(rate, per, pmt, pv, fv) {

    fv = parseFloat(fv);

    pmt = parseFloat(pmt);

    pv = parseFloat(pv);

    per = parseFloat(per);

    if ((per == 0) || (pmt == 0)) {

        return (0);

    }

    rate = eval((rate) / (per * 100));

    // Interest rate is 0
    if (rate == 0) {

        nper_value = -(fv + pv) / pmt;

    } else {

        nper_value = Math.log((-fv * rate + pmt) / (pmt + rate * pv)) / Math.log(1 + rate);

    }

    // nper_value = conv_number(nper_value, 0);

    return (nper_value);

}

function conv_number(expr, decplaces) { // This function is from David Goodman's Javascript Bible.

    var str = "" + Math.round(eval(expr) * Math.pow(10, decplaces));

    while (str.length <= decplaces) {

        str = "0" + str;

    }

    var decpoint = str.length - decplaces;

    return (str.substring(0, decpoint) + "." + str.substring(decpoint, str.length));

}

function FV(rate, periods, payment, value, type) {
    // Credits: algorithm inspired by Apache OpenOffice

    value = value || 0;
    type = type || 0;

    /*rate = utils.parseNumber(rate);
     periods = utils.parseNumber(periods);
     payment = utils.parseNumber(payment);
     value = utils.parseNumber(value);
     type = utils.parseNumber(type);
     if (utils.anyIsError(rate, periods, payment, value, type)) {
     return error.value;
     }*/

    // Return future value
    var result;
    if (rate === 0) {
        result = value + payment * periods;
    } else {
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
            result = value * term + payment * (1 + rate) * (term - 1) / rate;
        } else {
            result = value * term + payment * (term - 1) / rate;
        }
    }
    return -result;
}

function PMT(rate, periods, present, future, type) {
    // Credits: algorithm inspired by Apache OpenOffice

    future = future || 0;
    type = type || 0;

    /*rate = utils.parseNumber(rate);
     periods = utils.parseNumber(periods);
     present = utils.parseNumber(present);
     future = utils.parseNumber(future);
     type = utils.parseNumber(type);
     if (utils.anyIsError(rate, periods, present, future, type)) {
     return error.value;
     }*/

    // Return payment
    var result;
    if (rate === 0) {
        result = (present + future) / periods;
    } else {
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
            result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
        } else {
            result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
        }
    }
    return -result;
}

function CUMIPMT(rate, periods, value, start, end, type) {
    // Credits: algorithm inspired by Apache OpenOffice
    // Credits: Hannes Stiebitzhofer for the translations of function and variable names
    // Requires exports.FV() and exports.PMT() from exports.js [http://stoic.com/exports/]

    /*rate = utils.parseNumber(rate);
     periods = utils.parseNumber(periods);
     value = utils.parseNumber(value);
     if (utils.anyIsError(rate, periods, value)) {
     return error.value;
     }*/

    var error = {
        num: 0
    };

    // Return error if either rate, periods, or value are lower than or equal to zero
    if (rate <= 0 || periods <= 0 || value <= 0) {
        return error.num;
    }

    // Return error if start < 1, end < 1, or start > end
    if (start < 1 || end < 1 || start > end) {
        return error.num;
    }

    // Return error if type is neither 0 nor 1
    if (type !== 0 && type !== 1) {
        return error.num;
    }

    // Compute cumulative interest
    var payment = PMT(rate, periods, value, 0, type);
    var interest = 0;

    if (start === 1) {
        if (type === 0) {
            interest = -value;
            start++;
        }
    }

    for (var i = start; i <= end; i++) {
        if (type === 1) {
            interest += FV(rate, i - 2, payment, value, 1) - payment;
        } else {
            interest += FV(rate, i - 1, payment, value, 0);
        }
    }
    interest *= rate;

    // Return cumulative interest
    return interest;
}

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function (decimalLength, sectionLength, delimiterSection, delimiterDecimal) {
    var re = '\\d(?=(\\d{' + (sectionLength || 3) + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~decimalLength));

    return (delimiterDecimal ? num.replace('.', delimiterDecimal) : num).replace(new RegExp(re, 'g'), '$&' + (delimiterSection || ','));
};

function stringToFloat( string ) {
  var numbersOnly = string.replace( /[^0-9]/g, '' );
  if ( numbersOnly )
    return parseFloat( numbersOnly );
  else
    return 0;
}

function getMonthName( dateOrInt ) {

  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  if ( typeof dateOrInt === "number" )
    return monthNames[dateOrInt];
  else if ( typeof dateOrInt === "object" )
    return monthNames[dateOrInt.getMonth()];

}

function setTwoNumberDecimal(event) {
    this.value = parseFloat(this.value).toFixed(2);
}

/*
 ** Calculations
 */
(function ($) {
    "use_strict";

    /*
     ** Loan Calculator
     */
    var namespaceLoan = '.calculator.loan';
    var calcLoan = document.querySelector(namespaceLoan);
    // inputs
    var loaninput_amount = document.querySelector(namespaceLoan + ' #loan-amount');
    var loaninput_interest = document.querySelector(namespaceLoan + ' #interest-rate');
    var loaninput_term = document.querySelector(namespaceLoan + ' #loan-term');
    // outputs
    var loanoutput_amount = document.querySelectorAll(namespaceLoan + ' .output-loan-amount');
    var loanoutput_total = document.querySelectorAll(namespaceLoan + ' .total-payment');
    var loanoutput_interest = document.querySelectorAll(namespaceLoan + ' .total-interest');
    var loanoutput_monthly = document.querySelectorAll(namespaceLoan + ' .monthly-payment');

    function calculateLoan() {

        // Get the current values
        var currentAmount = stringToFloat(loaninput_amount.value);
        var currentInterest = loaninput_interest.value;
        var currentTerm = loaninput_term.value * 12;

        // Force breaking appearance
        if (
          isNaN(currentAmount) || isNaN(currentInterest) || isNaN(currentTerm)
          || currentAmount <= 0 || currentInterest <= 0 || currentTerm <= 0
        ) {
          loanoutput_total.forEach( function( element ){ element.innerHTML = "NaN"; } );
          loanoutput_interest.forEach( function( element ){ element.innerHTML = "NaN"; } );
          loanoutput_monthly.forEach( function( element ){ element.innerHTML = "NaN"; } );
          return;
        }

        var currentInterestAdj = (currentInterest / 100) / 12;

        // Calculate the new loan details
        var newTotalInterest = CUMIPMT(currentInterestAdj, currentTerm, currentAmount, 1, currentTerm, 0);
        newTotalInterest = Math.abs(newTotalInterest);
        var newTotalPayment = parseInt(currentAmount) + parseInt(newTotalInterest);
        var newMonthlyPayment = PMT(currentInterestAdj, currentTerm, currentAmount);
        newMonthlyPayment = Math.abs(newMonthlyPayment);

        // Output
        loaninput_amount.value = currentAmount;
        loanoutput_amount.forEach( function( element ){ element.innerHTML = currentAmount.format(0); } );
        loanoutput_total.forEach( function( element ){ element.innerHTML = newTotalPayment.format(0); } );
        loanoutput_interest.forEach( function( element ){ element.innerHTML = newTotalInterest.format(0); } );
        loanoutput_monthly.forEach( function( element ){ element.innerHTML = newMonthlyPayment.format(0); } );

        if ( typeof chartLoanTotalPayment !== 'undefined' && chartLoanTotalPayment )
          chartLoanTotalPayment.update({
              series: [[currentAmount], [newTotalInterest]]
          });
    }

    if (calcLoan) {
        // Run on page load
        calculateLoan();

        // Run on input change
        loaninput_amount.addEventListener('change', calculateLoan);
        loaninput_amount.addEventListener('keyup', calculateLoan);
        loaninput_interest.addEventListener('change', calculateLoan);
        loaninput_interest.addEventListener('keyup', calculateLoan);
        loaninput_interest.addEventListener('change', setTwoNumberDecimal);
        loaninput_term.addEventListener('change', calculateLoan);
        loaninput_term.addEventListener('keyup', calculateLoan);
    }


    /*
     ** Refinance Calculator
     */
    var namespaceRefinance = '.calculator.refinance';
    var calcRefinance = document.querySelector(namespaceRefinance);
    // inputs
    var refinanceinput_balance = document.querySelector(namespaceRefinance + ' #loan-balance');
    var refinanceinput_interest = document.querySelector(namespaceRefinance + ' #interest-rate');
    var refinanceinput_payment = document.querySelector(namespaceRefinance + ' #monthly-payment');
    var refinanceinput_term = document.querySelector(namespaceRefinance + ' #remaining-term');
    var refinanceinput_newinterest = document.querySelector(namespaceRefinance + ' #new-interest-rate');
    var refinanceinput_newpayment = document.querySelector(namespaceRefinance + ' #new-monthly-payment');
    var refinanceinput_newterm = document.querySelector(namespaceRefinance + ' #new-remaining-term');
    // outputs
    var refinanceoutput_total = document.querySelector(namespaceRefinance + ' #total-difference');
    var refinanceoutput_payment = document.querySelectorAll(namespaceRefinance + ' .payment-difference');
    var refinanceoutput_totalcont = document.querySelector(namespaceRefinance + ' #total-difference-container');
    var refinanceoutput_paymentcont = document.querySelector(namespaceRefinance + ' #payment-difference-container');
    var refinanceoutput_paymentDifferenceNegative = document.querySelectorAll(namespaceRefinance + ' .payment-difference-is-negative');
    var refinanceoutput_paymentDifferencePositive = document.querySelectorAll(namespaceRefinance + ' .payment-difference-is-positive');
    var refinanceoutput_newbalance = document.querySelector(namespaceRefinance + ' #new-loan-balance');
    var refinanceoutput_currentpayoffdate = document.querySelector(namespaceRefinance + ' #current-loan-payoff-date');
    var refinanceoutput_newpayoffdate = document.querySelector(namespaceRefinance + ' #new-loan-payoff-date');
    var refinanceoutput_newinterest = document.querySelector(namespaceRefinance + ' #output-new-interest-rate');
    var refinanceoutput_newpayment = document.querySelector(namespaceRefinance + ' #output-new-monthly-payment');
    var refinanceoutput_newtotal = document.querySelectorAll(namespaceRefinance + ' .output-new-total');

    var currentDate = new Date();

    function calculateRefinance(changed_input) {

        // Format input value for commas
        refinanceinput_balance.value = stringToFloat(refinanceinput_balance.value);

        // Get the current values
        var currentBalance = stringToFloat(refinanceinput_balance.value);
        var currentInterest = refinanceinput_interest.value;
        var currentPayment = stringToFloat(refinanceinput_payment.value);
        var currentTerm = refinanceinput_term.value * 12;

        var newInterest = refinanceinput_newinterest.value;
        var newPayment = stringToFloat(refinanceinput_newpayment.value);
        var newTerm = refinanceinput_newterm.value * 12;

        // Hard stop on new interest rate
        if ( newInterest < 2 ) newInterest = 2

        // Force breaking appearance
        if (
          isNaN(currentBalance) || isNaN(currentInterest) || isNaN(currentPayment) || isNaN(currentTerm) || isNaN(newInterest) || isNaN(newPayment) || isNaN(newTerm)
          || currentBalance <= 0 || currentInterest <= 0 || currentPayment <= 0 || currentTerm <= 0 || newInterest <= 0 || newPayment <= 0 || newTerm <= 0
        ) {
          refinanceoutput_total.innerHTML = "NaN";
          refinanceoutput_payment.forEach( function( element ){ element.innerHTML = "NaN"; } );
          refinanceoutput_newpayoffdate.innerHTML = "NaN";
          refinanceoutput_newinterest.innerHTML = "NaN";
          refinanceoutput_newpayment.innerHTML = "NaN";
        }

        var currentInterestAdj = (currentInterest / 100) / 12;
        var newInterestAdj = (newInterest / 100) / 12;

        // Find the new term amount, since the payment amount changed.
        if ('payment' == changed_input) {

            currentTerm = NPER(currentInterest, 12, currentPayment * -1, currentBalance, 0);
            newTerm = NPER(newInterest, 12, newPayment * -1, currentBalance, 0);

            // Output the new term values.
            if (!isNaN(currentTerm)) {
                refinanceinput_term.value = (currentTerm / 12).toFixed(0);
            }
            if (!isNaN(newTerm)) {
                refinanceinput_newterm.value = (newTerm / 12).toFixed(0);
            }
        }

        if (isNaN(currentTerm) || isNaN(newTerm)) {
            refinanceoutput_total.innerHTML = '0';
            refinanceoutput_payment.forEach( function( element ){ element.innerHTML = '0'; } );
            return false;
        }

        // Find the new payment amount, since the interest or term changed.
        if ('interest' == changed_input || 'term' == changed_input) {

            currentPayment = PMT(currentInterestAdj, currentTerm, currentBalance);
            currentPayment = Math.abs(currentPayment);
            newPayment = PMT(newInterestAdj, newTerm, currentBalance);
            newPayment = Math.abs(newPayment);

            refinanceinput_payment.value = currentPayment.format(0);
            refinanceinput_newpayment.value = newPayment.format(0);
        }

        // Calculate the rest of the new loan details.
        var currTotal = currentBalance - CUMIPMT(currentInterestAdj, currentTerm, currentBalance, 1, currentTerm, 0);
        var newTotal = currentBalance - CUMIPMT(newInterestAdj, newTerm, currentBalance, 1, newTerm, 0);

        var totalDifference = newTotal - currTotal;
        var paymentDifference = newPayment - currentPayment;

        // Output values
        if (totalDifference < 0) {
            refinanceoutput_totalcont.className = 'negative';
        } else {
            refinanceoutput_totalcont.className = 'positive';
        }
        totalDifference = Math.abs(totalDifference);
        refinanceoutput_total.innerHTML = totalDifference.format(0);

        if (paymentDifference < 0) {
            refinanceoutput_paymentcont.className = 'negative';
            refinanceoutput_paymentDifferenceNegative.forEach( function( element ){
              element.classList.remove("hidden-xs-up");
            } );
            refinanceoutput_paymentDifferencePositive.forEach( function( element ){
              element.classList.add("hidden-xs-up");
            } );
        } else {
            refinanceoutput_paymentcont.className = 'positive';
            refinanceoutput_paymentDifferencePositive.forEach( function( element ){
              element.classList.remove("hidden-xs-up");
            } );
            refinanceoutput_paymentDifferenceNegative.forEach( function( element ){
              element.classList.add("hidden-xs-up");
            } );
        }
        paymentDifference = Math.abs(paymentDifference);
        refinanceoutput_payment.forEach( function( element ){ element.innerHTML = paymentDifference.format(0); } );
        refinanceoutput_newtotal.forEach( function( element ){ element.innerHTML = newTotal.format(0); } );

        if ( refinanceoutput_newbalance )
          refinanceoutput_newbalance.value = currentBalance.format(0);
        if ( refinanceoutput_newinterest )
          refinanceoutput_newinterest.innerHTML = newInterest;
        if ( refinanceoutput_newpayment )
          refinanceoutput_newpayment.innerHTML = refinanceinput_newpayment.value;

        // Calculate payoff dates for both loans.
        var currentLoanPayoffDate = new Date();
        currentLoanPayoffDate.setMonth(currentLoanPayoffDate.getMonth() + parseInt(currentTerm));
        var currentLoanPayoffMonth = getMonthName(currentLoanPayoffDate);
        var currentLoanPayoffYear = currentLoanPayoffDate.getFullYear();

        var newLoanPayoffDate = new Date();
        newLoanPayoffDate.setMonth(newLoanPayoffDate.getMonth() + parseInt(newTerm));
        var newLoanPayoffMonth = getMonthName(newLoanPayoffDate);
        var newLoanPayoffYear = newLoanPayoffDate.getFullYear();

        // Update estimated payoff dates
        if ( refinanceoutput_currentpayoffdate )
          refinanceoutput_currentpayoffdate.innerHTML = currentLoanPayoffMonth + ' ' + currentLoanPayoffYear;
        if ( refinanceoutput_newpayoffdate )
          refinanceoutput_newpayoffdate.innerHTML = newLoanPayoffMonth + ' ' + newLoanPayoffYear;

        // Change charts
        var labels = ['Current Loan', 'New Loan'];
        if ( typeof chartRefinanceTotalPayment !== 'undefined' && chartRefinanceTotalPayment )
          chartRefinanceTotalPayment.update({
              labels: labels,
              series: [currTotal, newTotal]
          });
        if ( typeof chartRefinanceMonthlyPayment !== 'undefined' && chartRefinanceMonthlyPayment )
          chartRefinanceMonthlyPayment.update({
              labels: labels,
              series: [currentPayment, newPayment]
          });
    }

    function calculateRefinanceCurrInterest() {
        calculateRefinance('interest');
    }

    function calculateRefinanceNewInterest() {
        calculateRefinance('interest');
    }

    function calculateRefinanceCurrPayment() {
        calculateRefinance('payment');
    }

    function calculateRefinanceNewPayment() {
        calculateRefinance('payment');
    }

    function calculateRefinanceCurrTerm() {
        calculateRefinance('term');
    }

    function calculateRefinanceNewTerm() {
        calculateRefinance('term');
    }

    // this is messy
    $('body').on('click', '[data-toggle=tip].active', function () {
        restoreTooltip($(this));
    });

    function restoreTooltip($tooltip) {
        $tooltip.removeClass('active');
        var $tooltipContent = $tooltip.find('.tip-content');
        var tooltipOriginalContent = $tooltipContent.attr('original-text');
        $tooltipContent.text(tooltipOriginalContent);
    }

    function checkInterestRate($input) {
        if ('' === $input.val()) {
            return false;
        }
        if ($input.val() < 2) {
            $input.val('2.0');
            var $tooltip = $input.parent().prev();
            var $tooltipContent = $tooltip.find('.tip-content');
            var tooltipOriginalContent = $tooltipContent.text();
            $tooltipContent.text('That is an invalid entry, please enter a rate of 2% or greater to estimate a new student loan refinance.');
            $tooltipContent.attr('original-text', tooltipOriginalContent);
            $tooltip.addClass('active');
        }
    }

    if (calcRefinance) {
        // Run on page load
        calculateRefinance('term');

        // Run on input change
        refinanceinput_balance.addEventListener('change', calculateRefinanceCurrInterest);
        refinanceinput_balance.addEventListener('keyup', calculateRefinanceCurrInterest);
        refinanceinput_interest.addEventListener('change', calculateRefinanceCurrInterest);
        refinanceinput_interest.addEventListener('change', function () {
            checkInterestRate($(this));
        });
        refinanceinput_interest.addEventListener('blur', function () {
            checkInterestRate($(this));
            setTimeout(restoreTooltip, 3000, $(this).parent().prev());
        });
        refinanceinput_interest.addEventListener('keyup', calculateRefinanceCurrInterest);
        refinanceinput_interest.addEventListener('blur', function () {
            if ($('.tooltip.bs-tether-target-attached-top').length < 1 && !$('label[for=new-interest-rate] span[data-toggle=tooltip]').hasClass('triggered')) {
                $('label[for=new-interest-rate] span[data-toggle=tooltip]').tooltip('show').addClass('triggered').addClass('dont-hide-me-yet');
            }
        });
        refinanceinput_payment.addEventListener('change', calculateRefinanceCurrPayment);
        refinanceinput_payment.addEventListener('keyup', calculateRefinanceCurrPayment);
        refinanceinput_term.addEventListener('change', calculateRefinanceCurrTerm);
        refinanceinput_term.addEventListener('keyup', calculateRefinanceCurrTerm);
        refinanceinput_newinterest.addEventListener('change', calculateRefinanceNewInterest);
        refinanceinput_newinterest.addEventListener('keyup', calculateRefinanceNewInterest);
        refinanceinput_newinterest.addEventListener('change', function () {
             checkInterestRate($(this));
        });
        refinanceinput_newinterest.addEventListener('keyup', function () {
             checkInterestRate($(this));
        });
        refinanceinput_newinterest.addEventListener('blur', function () {
            checkInterestRate($(this));
            setTimeout(restoreTooltip, 3000, $(this).parent().prev());
        });
        refinanceinput_newpayment.addEventListener('change', calculateRefinanceNewPayment);
        refinanceinput_newpayment.addEventListener('keyup', calculateRefinanceNewPayment);
        refinanceinput_newterm.addEventListener('change', calculateRefinanceNewTerm);
        refinanceinput_newterm.addEventListener('keyup', calculateRefinanceNewTerm);
    }


    /*
     ** Repayment Calculator
     */
    var namespaceRepayment = '.calculator.repayment';
    var calcRepayment = document.querySelector(namespaceRepayment);
    // inputs
    var repaymentinput_balance = document.querySelector(namespaceRepayment + ' #loan-balance');
    var repaymentinput_interest = document.querySelector(namespaceRepayment + ' #interest-rate');
    var repaymentinput_term = document.querySelector(namespaceRepayment + ' #loan-term');
    var repaymentinput_increase = document.querySelector(namespaceRepayment + ' #monthly-increase');
    // outputs
    var repaymentoutput_total = document.querySelector(namespaceRepayment + ' #total-payment');
    var repaymentoutput_interest = document.querySelector(namespaceRepayment + ' #total-interest');
    var repaymentoutput_payment = document.querySelectorAll(namespaceRepayment + ' .monthly-payment');
    var repaymentoutput_monthlyIncrease = document.querySelectorAll(namespaceRepayment + ' .output-monthly-increase');
    var repaymentoutput_loanBalance = document.querySelectorAll(namespaceRepayment + ' .output-loan-balance');
    var repaymentoutput_interestRate = document.querySelectorAll(namespaceRepayment + ' .output-interest-rate');
    var repaymentoutput_payoffDate = document.querySelectorAll(namespaceRepayment + ' .payoff-date');

    function calculateRepayment() {

        // Get the current values
        var currBalance = stringToFloat(repaymentinput_balance.value);
        var currInterest = repaymentinput_interest.value;
        var currTerm = repaymentinput_term.value * 12;
        var paymentIncrease = stringToFloat(repaymentinput_increase.value);

        // Force breaking appearance
        if (
          isNaN(currBalance) || isNaN(currInterest) || isNaN(currTerm) || isNaN(paymentIncrease)
          || currBalance <= 0 || currInterest <= 0 || currTerm <= 0 || paymentIncrease < 0
        ) {
          repaymentoutput_total.innerHTML = "NaN";
          repaymentoutput_interest.innerHTML = "NaN";
          repaymentoutput_payment.forEach( function( element ){ element.innerHTML = "NaN"; } );
          repaymentoutput_monthlyIncrease.forEach( function( element ){ element.innerHTML = "NaN"; } );
          repaymentoutput_loanBalance.forEach( function( element ){ element.innerHTML = "NaN"; } );
          repaymentoutput_interestRate.forEach( function( element ){ element.innerHTML = "NaN"; } );
          repaymentoutput_payoffDate.forEach( function( element ){ element.innerHTML = "NaN"; } );
          return;
        }

        var currInterestAdj = (currInterest / 100) / 12;

        // Calculate monthly payment
        var currPayment = PMT(currInterestAdj, currTerm, currBalance);
        currPayment = Math.abs(currPayment);
        var newPayment = Number(currPayment + paymentIncrease);

        // Calculate total interest
        var runningBalance = currBalance;
        var paymentTotal = 0;
        var paymentInterest = 0;
        var newTotalInterest = 0;
        var paymentPrincipal = 0;
        var extraPrincipal = 0;
        var runningBalances = [];
        var runningInterests = [];
        var date = new Date();
        var runningMonth = date.getMonth() + 1;
        var runningYear = date.getFullYear();
        var runningYears = [];
        while (Number(Math.round(runningBalance + 'e5') + 'e-5') > 0) {

            paymentTotal = (currPayment <= runningBalance)
                ? currPayment
                : runningBalance + runningBalance * currInterestAdj;

            paymentInterest = (paymentTotal > 0)
                ? currInterestAdj * runningBalance
                : 0;
            newTotalInterest += paymentInterest;

            paymentPrincipal = (paymentTotal > 0)
                ? Math.min((paymentTotal - paymentInterest), runningBalance)
                : 0;

            extraPrincipal = ((runningBalance - paymentPrincipal) >= paymentIncrease)
                ? paymentIncrease
                : runningBalance - paymentPrincipal;

            runningBalance = runningBalance - paymentPrincipal - extraPrincipal;
            if (runningBalance < 0) {
                runningBalance = 0;
            }
            runningBalances.push(runningBalance);
            runningInterests.push(paymentInterest);

            runningYears.push(runningYear);
            runningMonth++;
            if (runningMonth > 12) {
                runningMonth = 1;
                runningYear++;
            }

        }
        var runningInterestBalance = newTotalInterest;
        var runningTotals = [];
        for (var i = 0, len = runningBalances.length; i < len; i++) {

            runningInterestBalance = runningInterestBalance - runningInterests[i];
            if (runningInterestBalance < 0) {
                runningInterestBalance = 0;
            }
            runningTotals.push(runningBalances[i] + runningInterestBalance);

        }

        // Calculate total payment
        var newTotal = Number(currBalance) + newTotalInterest;

        // Get human readable payoff date
        var payoffDate = getMonthName( runningMonth - 1 ) + " " + runningYear;

        // Output values
        repaymentinput_balance.value = currBalance;
        repaymentoutput_total.innerHTML = newTotal.format(0);
        repaymentoutput_interest.innerHTML = newTotalInterest.format(0);
        repaymentoutput_payment.forEach( function( element ){ element.innerHTML = newPayment.format(0); } );
        repaymentoutput_monthlyIncrease.forEach( function( element ){ element.innerHTML = repaymentinput_increase.value; } );
        repaymentoutput_loanBalance.forEach( function( element ){ element.innerHTML = stringToFloat(repaymentinput_balance.value).format(0); } );
        repaymentoutput_interestRate.forEach( function( element ){ element.innerHTML = repaymentinput_interest.value; } );
        repaymentoutput_payoffDate.forEach( function( element ){ element.innerHTML = payoffDate; } );

        // Change chart
        if ( typeof chartRepaymentRemainingPayments !== 'undefined' && chartRepaymentRemainingPayments )
        chartRepaymentRemainingPayments.update({
            labels: runningYears,
            series: [runningTotals, runningBalances]
        });
    }

    if (calcRepayment) {
        // Run on page load
        calculateRepayment();

        // Run on input change
        repaymentinput_balance.addEventListener('change', calculateRepayment);
        repaymentinput_balance.addEventListener('keyup', calculateRepayment);
        repaymentinput_interest.addEventListener('change', calculateRepayment);
        repaymentinput_interest.addEventListener('keyup', calculateRepayment);
        repaymentinput_term.addEventListener('change', calculateRepayment);
        repaymentinput_term.addEventListener('keyup', calculateRepayment);
        repaymentinput_increase.addEventListener('change', calculateRepayment);
        repaymentinput_increase.addEventListener('keyup', calculateRepayment);
    }

}(jQuery));
